enum RecordType {
    SHOW = 0,
    SEASON = 1,
  }
  
  export default RecordType;